import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login';

@Component({
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
})
export class AdminComponent {
    listing: string;
    showDialog = false;

    constructor(private router: Router, private _loginService: LoginService) {}

    ngOnInit() {
    }

    onStatus(status: string): void {
        // Gets status from tabs and sets the listing ID
        this.listing = status;
        this.router.navigateByUrl(`/admin/${status}`);
    }

    onClickToggle(toggle: boolean): void {
        // Tab button outputs EventEmitter which triggers modal
        this.showDialog = toggle;
    }
}
